import { render, staticRenderFns } from "./footerCompontent.vue?vue&type=template&id=7abc0ca1&scoped=true"
import script from "./footerCompontent.vue?vue&type=script&lang=js"
export * from "./footerCompontent.vue?vue&type=script&lang=js"
import style0 from "./footerCompontent.vue?vue&type=style&index=0&id=7abc0ca1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abc0ca1",
  null
  
)

export default component.exports